/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ xp: NonNullable<unknown>, days: NonNullable<unknown> }} Leveling_Reward_Activity_OneInputs */



/**
* | output |
* | --- |
* | "{xp} XP in {days} day" |
*
* @param {Leveling_Reward_Activity_OneInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_reward_activity_one = /** @type {((inputs: Leveling_Reward_Activity_OneInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Reward_Activity_OneInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.xp} XP за ${i?.days} день`)
	return /** @type {LocalizedString} */ (`${i?.xp} XP in ${i?.days} day`)
});